import { z } from "zod";
import { reservationCheckInStatusValues } from "../../statuses/reservation-check-ins/reservation-check-in-status";

const agendaReservationStatusValues = [
    ...reservationCheckInStatusValues,
    "ACTIVE", // for reservations that are not checked in or out but are within the reservation time
    "FULFILLED", // for reservations that are checked out or after the reservation time
] as const;
const agendaReservationStatusValueZodEnum = z.enum(
    agendaReservationStatusValues,
);
type AgendaReservationStatusValue =
    (typeof agendaReservationStatusValues)[number];

export { agendaReservationStatusValueZodEnum };
export type { AgendaReservationStatusValue };
